<template>
    <div class="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-5 mb-5">
        <div class="card">
            <img :src="rutathumbnail+form.Imagen" class="card-img-top pointer" alt="ENES" data-backdrop="true" data-toggle="modal" data-target="#exampleModal" @click="Ver">
            <div class="row crad-fecha-evento">
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
                    <div class="bg-001">
                        <h2>{{func_getData('dia',form.FechaIni)}}</h2>
                        <h5>{{func_getData('mes',form.FechaIni)}}</h5>
                        <p>{{func_getData('hora',form.FechaIni)}}</p>
                        </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div class="bg-002">
                        <h6> <a href="#" style="pointer-events:none;">{{form.Titulo | subStr}}</a></h6>
                    </div>
                </div>
            </div>
        </div>
                
        <modal-component v-if="showModal" @cerrar="showModal = false" size='modal-lg'>
			<template slot="titulo" >
                 {{form.dia+' '+func_getData('mes',form.FechaFin)+' '+anio}}
            </template>
			<template slot="contenido" >
                <h4 class="color_Azul">{{form.Titulo}}</h4>
                <hr class="titulo_hr">

                <div class="row justify-content-center">
                    <div class="col-12 col-sm-12 col-md-9 col-lg-8 col-xl-8">
                        <figure>
                            <img :src="rutafile+form.Imagen" alt="Difusión" class="img-fluid">
                        </figure>
                    </div>
                </div>
                <div class="description" v-html="form.Descripcion"></div>
                <h6 class="color_Azul">Fecha: {{func_getData('dia',form.FechaIni)+' de '+func_getData('mes',form.FechaIni)+' de '+anio}} al {{func_getData('dia',form.FechaFin)+' de '+func_getData('mes',form.FechaFin)+' de '+anio}}</h6>
                <h6 class="color_Azul">Hora {{func_getData('hora',form.FechaIni)}} a {{func_getData('hora',form.FechaFin)}}</h6>
			</template>
		</modal-component>
    </div>
</template>

<script>
import ModalComponent from "@/components/ModalComponent";
export default {
    components:{
        ModalComponent
    },
    props:['value','rutafile','rutathumbnail','anio','mes'],
    data() {
        return {
            form:this.value,
            showModal:false
        }
    },methods: {
        Verificarnumero(value){
            if(value < 10)
                return '0'+value;
            return value
        },
        Ver(){
            this.showModal = true;
        },
        cnvertfecha(fecha){
            var date = new Date(fecha);

            let day = date.getDate();
            let month = date.getMonth() + 1
            let year = date.getFullYear();
            let value = '';
            if(month < 10){
               value = `${day}-0${month}-${year}`;
            }else{
                value = `${day}-${month}-${year}`;
            }

            return value;
        },
        func_getData(type,data){
            var parData=data.split(" ");
            if(type=="hora"){
                return parData[1] + " "+parData[2];
            }else if(type=="dia"){
                var parDia=parData[0].split("-");
                return parDia[2];
            }else if(type=="mes"){
                var parDia=parData[0].split("-");
                return this.get_Mes(parDia[1]);
            }
        },
        get_Mes(mes){
            if(mes=="01"){ return "Enero";} else
            if(mes=="02"){ return "Febrero";}else
            if(mes=="03"){ return "Marzo";}else
            if(mes=="04"){ return "Abril";}else
            if(mes=="05"){ return "Mayo";}else
            if(mes=="06"){ return "Junio";}else
            if(mes=="07"){ return "Julio";}else
            if(mes=="08"){ return "Agosto";}else
            if(mes=="09"){ return "Septiembre";}else
            if(mes=="10"){ return "Octubre";}else
            if(mes=="11"){ return "Noviembre";}else
            {
                return "Diciembre";
            }
        }
    },
    filters: {
        subStr: function(string2) {
            let add = '';
            let string = (string2 == null || string2 == undefined)?'':string2;
            if(string !='')
                if(string.length>40)
                    add = '...';
            return string.substring(0,40)+add;
        }
    }
}
</script>